// LP2 – Minimaler Header: NUR Logo + Anmelden + Demo testen.
// G4: Volllogo (hell) auf hellem Header; auf sehr schmalen Screens nur das Icon.
export default function LandingHeader({ onLogin, onTest }) {
  return (
    <header className="hdr">
      <div className="wrap hdr-in">
        <a href="#top" className="brand" data-testid="lp2-logo">
          <img
            className="brand-logo-full"
            src="/brand/clartext-logo-full-light.svg"
            alt="CLartext"
          />
          <img
            className="brand-logo-icon"
            src="/brand/clartext-icon.svg"
            alt="CLartext"
          />
        </a>
        <div className="hdr-actions">
          <span className="lnk" data-testid="lp2-login" onClick={onLogin}>Anmelden</span>
          <button className="btn btn-primary btn-sm" data-testid="lp2-nav-cta" onClick={onTest}>
            14 Tage kostenlos testen
          </button>
        </div>
      </div>
    </header>
  );
}
